<template>
    <div class="modal" v-if="$root.search.opened">
        <div class="modal__container">
            <div class="modal__inner  modal__inner--secondary">

                <h3 class="modal__ttl  modal__ttl--primary">{{ __('Type below and press \'Enter\' to search...') }}</h3>

                <form :action="formAction" class="form  form--primary">
                    <div class="form__field">
                        <input type="text" name="query" id="search-field" class="form__input  form__input--quaternary" :placeholder="__('Search events, venues, artists & more')" />
                    </div>

                    <input type="submit" class="btn btn--quaternary" :value="__('Search')" />

                    <a href="#" class="modal__close  modal__close--secondary" @click="close">
                        <i class="fas fa-times"></i>
                        <span>{{ __('Close') }}</span>
                    </a>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'search',

        props: {
            formAction: {
                type: String,
                default: '/events/search'
            }
        },

        methods: {
            close() {
                event.preventDefault();

                this.$root.search.opened = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "../../sass/base/_variables.scss";
.modal__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
#search-field {
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Search.vue